// extracted by mini-css-extract-plugin
module.exports = {"mainSvg":"OrientationPortrait_mainSvg__2PyHE","activeColor":"OrientationPortrait_activeColor__2XKBo","defaultColor":"OrientationPortrait_defaultColor__2-3at"};